module.exports = __webpack_public_path__ + "media/advertise2.1aeecc79.mp3";